import React from 'react'
import styles from "./style.module.scss"
import { useApi } from "../../hooks/apiReq"
import { useNavigate } from "react-router-dom"
import { Loading } from '../../components'

interface obj {
   name: string,
   id: number
}

const GameOptions: React.FC = () => {
   const
      { loading, error, data } = useApi({ path: "https://opentdb.com/api_category.php", method: "get" }),
      navigate = useNavigate(),
      diffOp = ["easy", "medium", "hard"],
      quesNumbers = Array.from(Array(11)),
      catOp = data ? data.trivia_categories : []
   // console.log(data, loading, error);


   function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
      e.preventDefault()
      const data: any = {}
      Object.values(e.target).forEach((input: any) =>
         !input.name ? null : data[input.name] = input.value)
      navigate(`/quiz?category=${data.category}&difficulty=${data.difficulty}&quesAmount=${data.numQues}`)
   }

   const CategoryOptions: React.FC = () => catOp.map((d: obj) =>
      <option key={d.id} value={d.id}>{d.name}</option>)

   const NumQues = () => quesNumbers.map((s: any, i: number) =>
      <option key={`tt${i}`} value={i + 10}>{i + 10}</option>)

   const DifficultyOptions = () => diffOp.map((d: string) =>
      <option key={d} value={d}>{d}</option>)

   return (
      <div className={`${styles.container} d-flex `}>
         {loading ? <Loading /> : error ? <p>{error}</p> :

            <form className={`${styles.form} d-flex card`} onSubmit={handleSubmit} >
               <h1>Let's choose our questions</h1>

               <label htmlFor="category">category</label>
               <select required name="category" id="category">
                  <CategoryOptions />
               </select>

               <label htmlFor="numQues">number of questions</label>
               <select required name="numQues" id="">
                  {NumQues()}
               </select>

               <label htmlFor="difficulty">difficulty</label>
               <select name="difficulty" required defaultValue="easy" id="">
                  {DifficultyOptions()}
               </select>

               <div className="btnbox">
                  <button type='submit'>let's go!</button>
               </div>
            </form>
         }
      </div>
   )
}

export default GameOptions